import { render, staticRenderFns } from "./CardUpgradePlan.vue?vue&type=template&id=214a8cc0&scoped=true&"
import script from "./CardUpgradePlan.vue?vue&type=script&lang=js&"
export * from "./CardUpgradePlan.vue?vue&type=script&lang=js&"
import style0 from "./CardUpgradePlan.vue?vue&type=style&index=0&id=214a8cc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214a8cc0",
  null
  
)

export default component.exports